module.exports = __webpack_public_path__ + "img/image03.f1704bfa.png";